import React from 'react';
import { Box, Stack, useMediaQuery, useTheme } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import FormField from './FormField';
import QuestionLabel from './QuestionLabel';
import { defaultCountries } from 'react-international-phone';
import { useTranslation } from 'react-i18next';

export default function PaymentForm() {
  const { t } = useTranslation();
  const {
    register,
    formState: { errors },
  } = useFormContext();
  const theme = useTheme();
  const mobileScreen = useMediaQuery(theme.breakpoints.down('sm'));

  // Prepare country and dial codes
  const countryCodes = [
    ...new Map(
      defaultCountries.map((c) => [
        c[1],
        { label: c[0], value: c[1].toUpperCase() },
      ]),
    ).values(),
  ];
  const dialCodes = [
    ...new Map(
      defaultCountries.map((c) => [c[2], { label: c[0], value: c[2] }]),
    ).values(),
  ];

  const fields = [
    {
      type: 'select',
      label: t('final_dial_code'),
      name: 'paymentDetails.countryCode',
      options: dialCodes,
    },
    { type: 'text', label: t('final_phone'), name: 'paymentDetails.tel' },
    {
      type: 'select',
      label: t('final_country'),
      name: 'paymentDetails.countryCodePayment',
      options: countryCodes,
    },
    {
      type: 'text',
      label: t('final_address'),
      name: 'paymentDetails.addressLine1',
    },
    { type: 'text', label: t('final_city'), name: 'paymentDetails.locality' },
    {
      type: 'text',
      label: t('final_postal_code'),
      name: 'paymentDetails.postalCode',
    },
    {
      type: 'text',
      label: t('final_first_name'),
      name: 'paymentDetails.paymentName',
    },
    {
      type: 'text',
      label: t('final_last_name'),
      name: 'paymentDetails.paymentSurname',
    },
  ];

  return (
    <Stack spacing={4} sx={{ height: '100%' }}>
      <Box
        sx={(theme) => ({
          display: 'grid',
          gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
          rowGap: 4,
          columnGap: 4,
          [theme.breakpoints.down('sm')]: { gridTemplateColumns: '1fr' },
        })}
      >
        {fields.map((field) => (
          <Box key={field.name} sx={{ minWidth: 0 }}>
            <QuestionLabel
              component='label'
              sx={{ mb: 1, color: 'rgba(255,255,255,0.8)' }}
              collapsible={!mobileScreen}
            >
              {field.label}
            </QuestionLabel>
            <FormField
              type={field.type}
              label={null}
              ariaLabel={field.label}
              name={field.name}
              options={field.options}
              register={register}
              error={errors?.paymentDetails?.[field.name.split('.')[1]]}
              helperText={
                errors?.paymentDetails?.[field.name.split('.')[1]]?.message
              }
              fullWidth
            />
          </Box>
        ))}
      </Box>
    </Stack>
  );
}
